import React, { useState } from "react"
import { Card, CardBody, Collapse, Table } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import { getMonthName } from "utils/utils"
import MonitorConsumptionReporFilter2 from "./filter"
import MonitorConsumptionHeaderTitle from "./Header"
import PaginationLinks from "components/Pagination"

const MonitorConsumptionReportListComponent2 = ({
  data,
  error,
  loading,
  onChangeOrdering,
  onExportBtnClick,
  onSearchHandler,
  exportStatus,
  onPageClick,
  onChangeRowNumber,
  columns,
  visibleColumns,
  onToggleColumn,
  onReorder,
}) => {
  const navigate = useNavigate()
  const [filterOpen, setFilterOpen] = useState(false)
  const [filter, setFilter] = useState({})

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setFilter(data)
    onSearchHandler(data)
  }

  // generate data for chat design
  let consumptData = [] // store generated data for chart design
  if (data) {
    consumptData = data?.data?.map(stock => {
      const items = stock.item_name
      const in_qty = !isNaN(stock.totalQty) ? stock.totalQty : 0

      const out_qty = !isNaN(stock.ProviderTotalConsums)
        ? stock.ProviderTotalConsums
        : 0

      const balance = in_qty - out_qty
      return { items, in_qty, out_qty, balance: balance }
    })
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}

          <CustomHeaderTitle
            loading={loading}
            // pageRowNumberOptions={[20, 100, 150]}
            title={"CONSUMPTION REPORTS 2"}
            lgColumn={6}
            exportBtn={true}
            exportBtnLoading={exportStatus?.loading}
            onExportBtnClick={onExportBtnClick}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={false}
            rightBtn={false}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
            orderingOptions={[
              { value: "date", name: "Date" },
              //   { value: "date", name: "Submission Date" },
            ]}
          />
          <Collapse isOpen={filterOpen}>
            {/* Consumption Report 2 Filter Component  */}
            <MonitorConsumptionReporFilter2
              loading={loading}
              error={error}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
              columns={columns}
              onToggleColumn={onToggleColumn}
              onReorder={onReorder}
            />
          </Collapse>

          <div className="table-responsive">
            {/* Consumptin Header Component */}
            <MonitorConsumptionHeaderTitle error={error} />
            <Table className="table mb-0">
              <thead>
                <tr>
                  {visibleColumns.map(column => (
                    <th key={column.key} style={column.style}>
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((row, index) => (
                  <tr key={index}>
                    {visibleColumns.map(column => (
                      <td key={column.key} style={column.style}>
                        {column.render(row, index)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
            {/* Pagination Component  */}
            {data?.meta && (
              <PaginationLinks meta={data?.meta} onPageClick={onPageClick} />
            )}
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonitorConsumptionReportListComponent2
